export default "/assets/images/rookie-parent-small.c80e2fd2bcafe2ac.webp";